import Commons from '../../../../Services/Common/Common';

export const M_RNM_DAI_Schema = {
  mapper: {
    /** 안전보건제안 목록 조회 */
    search1: {
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd),
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd),
      UserId: (context) => context.userInfo?.userid,
      DepCd: (context) => Commons.EncryptAES(context.depCd ?? ''),
      GongjongCd: (context) => Commons.EncryptAES(context.gongjongCd ?? ''),
      Year: (context) => Commons.EncryptAES(context.year ?? ''),
      Month: (context) => Commons.EncryptAES(context.month ?? ''),
    },
    /** 안전보건제안 삭제 */
    delete1: {
      CustCd: (context) => Commons.EncryptAES(context.search?.custCd || ''),
      NearMissSeq: (context) => context.nearMissSeq,
    },
  },
};
